import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.1/js/sparta-global-functions-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import focusTrapUtility from "utilities/global/focus-trap-utility/1.2.2/js/focus-trap-utility";
import "utilities/global/sparta-global-data-utility/1.0.0/js/sparta-global-data-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.2/js/sparta-mediaquery-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.1.5/js/sparta-style-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";










const focusTrap = focusTrapUtility({});


const classDefaults = {
  debug: false,
  evtNamespace: 'spaUILayer',
  closeLayerNameSpace: 'info-layer-evt',
  initNamespace: 'sparta-ui-layers-utility',
  scrollNamespace: 'scrollfix',
  globalReady: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  globalReadyToken: '',
  layerClass: 'spa-ui-layer',
  layerPosition: '',
  linkClass: 'spa-ui-layer-link',
  closeClass: 'spa-ui-layer-close',
  openClass: 'spa-ui-layer-opened',
  adaLayerID: 'SpartaUILayer',
  adaCloseID: 'Close',
  modalLayerClass: 'spa-ui-modal',
  infoLayerClass: 'spa-ui-info',
  layerLinkOffset: 8, 
  nextZIndex: 1001,
  continueLinkPostfixID: 'ContinueLink',
  backLinkPostfixID: 'BackLink',
  spartaLayoutContainer: '.spa-layout-container', 
};


const linkDefaults = {
  type: null, 
  width: null, 
  layerId: null,
  layerCloseId: null,
  layerClass: 'spa-ui-layer',
  optionalClasses: '',
  onOpen: '', 
  onClose: '', 
  closeButton: true, 
  closeTriggers: [], 
  closeOnEscape: true, 
  closeAdaText: ' ',
  closeAdaTextSpacer: ': ',
  closeAdaTextOverride: '',
  interstitialType: '',
  adaCloseFocus: false, 
  interstitialBranding: 'default',
  dynamicContent: false,
  loadingText: '',
  targetAction: '',
  modalLayer: {
    class: classDefaults.modalLayerClass,
    width: 600,
  },
  infoLayer: {
    class: classDefaults.infoLayerClass,
    layerAdjustTop: 10,
    layerAdjustLeft: 10,
    width: {
      small: {
        chars: 350,
        width: 250,
        class: `${classDefaults.infoLayerClass}-small`,
      },
      medium: {
        chars: 800,
        width: 400,
        class: `${classDefaults.infoLayerClass}-medium`,
      },
      large: {
        chars: 0,
        width: 400,
        class: `${classDefaults.infoLayerClass}-large`,
      },
      default: {
        width: 250,
        class: `${classDefaults.infoLayerClass}-large`,
      },
    },
  },
};

const EVENTS = {
  MODAL_OPENED: 'MODAL_OPENED.spartaUILayersUtility',
  MODAL_CLOSED: 'MODAL_CLOSE.spartaUILayersUtility',
  FREEZE_SCROLL: 'FREEZE_SCROLL.spartaUILayersUtility',
  UNFREEZE_SCROLL: 'UNFREEZE_SCROLL.spartaUILayersUtility',
};


const options = {
  debug: false,
  $applicationContainer: undefined,
  $body: $('body'),
  $html: $('html'),
  $window: $(window),
  $document: $(document),
  $context: undefined,
};





class SpartaUILayersUtility {





  constructor() {

    this.options = Object.assign({}, classDefaults, options);

    this.options.globalReadyToken = spartaEventsUtility.sub(`${this.options.globalReady}`, this._addListeners.bind(this));


    this.options.windowWidth = this.options.$window.width();
  }








  get layers() {
    let layersObj;

    const lang = spartaStoreUtility.getData('lang').split('-')[0];


    const widgetContext = spartaStoreUtility.getData('applicationContext');

    if (widgetContext) {
      layersObj = window.spaWidgetParams[widgetContext.name][widgetContext.version].global[lang].layers;
    } else {
      layersObj = window.spaParams.global[lang].layers;
    }

    return layersObj;
  }

  get EVENTS() {
    return EVENTS;
  }






  _addListeners() {

    this.options.$applicationContainer = $(spartaStoreUtility.getData('applicationContainer'));

    spartaEventsUtility.unsubByToken(this.options.globalReadyToken);

    this.options.$applicationContainer.on(`click.${this.options.evtNameSpace}`, `.${this.options.linkClass}`, this._onLayerLinkClick.bind(this));

    this.options.$applicationContainer.on(`animationend.${this.options.evtNamespace} oAnimationEnd.${this.options.evtNamespace} webkitAnimationEnd.${this.options.evtNamespace}`, this._infoLayerAnimationEnd.bind(this));
  }







  displayPopup(url, windowName, args = 'width=750,height=450,resizable,scrollbars') {
    const defaultArgs = $.extend({}, args);
    const newWindow = window.open(url, windowName, args);
    newWindow.focus();

    return false;
  }




  addPopupWindowHelper(elements) {
    const popupElements = Array.prototype.slice.call(elements, 0);

    popupElements.forEach((elem) => {
      if (elem.getAttribute('data-popup-event-attached')) {
        return;
      }
      elem.addEventListener('click', ((event) => {
        event.preventDefault();

          let args = '';
        const $elem = $(elem);
        const defaults = {
          block: false,
          height: 600,
          href: $elem.attr('href'),
          menubar: false,
          resizable: true,
          scrollbars: true,
          size: null,
          status: false,
          width: 400,
          windowName: 'spawin',
          x: 0,
          y: 0,
        };
        const options = Object.assign({}, defaults, ($elem.data('options') || {}));
        const sizes = {
          large: {
            height: 600,
            width: 800,
          },
          medium: {
            height: 400,
            width: 600,
          },
          small: {
            height: 200,
            width: 300,
          },
        };

          if (options.size) {
          options.width = sizes[options.size].width;
          options.height = sizes[options.size].height;
        }



        options.y = Math.floor((screen.availHeight - (options.height || screen.height)) / 2) - (screen.height - screen.availHeight);
        options.x = Math.floor((screen.availWidth - (options.width || screen.width)) / 2) - (screen.width - screen.availWidth);


        if (!options.block) {
          args = `${args}width=${options.width},height=${options.height},left=${options.x},top=${options.y}`;

            ['menubar', 'resizable', 'scrollbars', 'status'].forEach((toolbarFeature) => {
            if (options[toolbarFeature]) {
              args += `,${toolbarFeature}`;
            }
          });
        }

          this.displayPopup(options.href, options.windowName, args);

          elem.classList.add('force-visited');
        return false;
      }));
      elem.setAttribute('data-popup-event-attached', "1");
    });
  }







  _onLayerLinkClick(event) {
    const $this = $(event.currentTarget);

    this.openLayer($this, event);
  }







  _infoLayerAnimationEnd(e) {
    const $target = $(e.target);


    if ($target.hasClass('spa-ui-animate-fadeOutUp') || $target.hasClass('spa-ui-animate-fadeOutDown')) {
      $target.hide();
    }
  }









  _setLayerOptions(linkSpecificSettings = {}, contentOptions = {}, linkOptions = {}) {
    return Object.assign({}, linkDefaults, linkSpecificSettings, contentOptions, linkOptions);
  }









  openLayer(obj, e, layerOptions) {
    const event = e || {};

    let $obj = obj;
    let linkOptions = {};

    let $layer;
    let $link;
    let $content;
    let contentId;
    let contentOptions;


    if (event.type) {
      event.preventDefault();
    }


    if ($obj && !$obj.jquery) {
      $obj = $(obj);
    }


    if (!$obj || !$obj.length) {
      this._debug('Error: spartaUILayer: Nothing passed in');

      return false;
    }


    this.options.$applicationContainer = event.$applicationContainer || $(spartaStoreUtility.getData('applicationContainer'));


    if ($obj.hasClass(this.options.linkClass)) {
      $link = $obj;

      linkOptions = $link.data('options') || {};
      contentId = $link.attr('rel');


      if (linkOptions.interstitialType) {
        linkOptions.type = 'modal';
        contentId = linkOptions.rel || `${linkOptions.interstitialType}-${linkOptions.interstitialBranding || 'default'}`;
      }

      $content = $(`#${contentId}`) || null;
    } else {
      $content = $obj;
      $link = this.options.$applicationContainer;
      contentId = $content.attr('id');
    }

    contentOptions = $content.data('options') || {};


    const linkSpecificSettings = {
      closeADALabel: spartaGlobalFunctions.getGlobalParams('closeADALabel') || 'x: ',
      closeText: spartaGlobalFunctions.getGlobalParams('closeText') || 'close',
      $content,
      contentId,
      endContentMsg: 'End of content',
      returnFocusToLink: event.currentTarget ? $(event.currentTarget) : this.options.$applicationContainer,
      position: {
        browserWidth: this.options.$body.width(),
        applicationWidth: this.options.$applicationContainer.width(),
        activeMouseTop: event.pageY,
        activeMouseLeft: event.pageX,
        linkWidth: $link.width(),
        linkHeight: $link.height(),
        linkOffsetTop: $link.offset().top,
        linkOffsetLeft: $link.offset().left,
        screenTop: this.options.$document.scrollTop(),
      },
    };






    let o = this._setLayerOptions(linkSpecificSettings, contentOptions, linkOptions);


    o = Object.assign({}, o, layerOptions);


    if (typeof o.$content === 'undefined') {
      o.$content = $(`#${o.contentId}`);


      if (typeof o.$content === 'undefined' && typeof o.interstitialType === 'undefined') {
        this._debug(`cannot find: ${o.contentId}`);

        return false;
      }
    }


    o.layerId = `${o.contentId}${this.options.adaLayerID}`;
    o.layerCloseId = `${o.layerId}${this.options.adaCloseID}`;


    switch (o.type) {
      case 'modal':
        $layer = this._openModalLayer(o, $layer, $link);

        this.options.$applicationContainer.addClass('spa-ui-modal-open');

        break;
      case 'info':
        $layer = this._openInfoLayer(o, $layer, $link);

        this.options.$applicationContainer.addClass('spa-ui-tooltip-open');

        break;
      default:
        return false;
    }


    if (o.layerPosition && $layer.length) {
      $layer[0].firstElementChild.classList.add('spa-ui-position-' + o.layerPosition);
    }


    const $modalElement = $layer.find('.spa-content');
    const $contentDiv = $modalElement.find('.content');
    const contentDiv = $contentDiv[0];
    const originalWindowWidth = this.options.$window.width();
    const resizeContentBody = function (event) {
      if (!contentDiv) {
        return false;
      }

      let contentBodyChanged = false;


      let origMaxHeight = parseInt(contentDiv.getAttribute('data-orig-max-height'), 10);
      if (!origMaxHeight && o.type === 'modal') {
        origMaxHeight = parseInt(window.getComputedStyle(contentDiv).maxHeight, 10);
        contentDiv.setAttribute('data-orig-max-height', origMaxHeight);
      }


      if ($modalElement[0].scrollHeight > Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) {
        const amountToReduce = $modalElement[0].scrollHeight - Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        contentDiv.style.maxHeight = `${contentDiv.offsetHeight - amountToReduce - 25}px`;
        contentBodyChanged = true;
      } else {

        const amountToIncrease = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - $modalElement[0].scrollHeight;
        if (contentDiv.offsetHeight + amountToIncrease > origMaxHeight) {
          contentDiv.style.maxHeight = `${origMaxHeight}px`;
        } else if (amountToIncrease > 0) {
          contentDiv.style.maxHeight = `${(contentDiv.offsetHeight + amountToIncrease) - 25}px`;
        }

        contentBodyChanged = true;
      }


      if (contentBodyChanged) {
        $contentDiv.trigger('scroll.uilayer_content');
      }
    };


    if (contentDiv) {
      resizeContentBody.call(this);

      this.options.$window.on('resize.closeModal orientationchange.closeModal', resizeContentBody.bind(this));
    }

    $layer.data('type', o.type);

    if (o.returnFocusToLink && o.returnFocusToLink[0] && o.returnFocusToLink[0].id) {
      $layer.data('returnFocusToLink', `#${o.returnFocusToLink[0].id}`);
    } else {
      $layer.data('returnFocusToLink', 'body');
    }

    $layer.data('contentId', o.contentId);


    const $closeButton = $layer.find(`.${this.options.closeClass}`);


    const _closeLayer = function () {
      this.closeLayer($layer);


      this.options.$body.off(`keydown.${this.options.evtNamespace}`);
    };

    $closeButton.off(`click.${this.options.evtNamespace}`).on(`click.${this.options.evtNamespace}`, _closeLayer.bind(this));


    if (o.closeOnEscape && o.closeButton === true) {
      const _closeLayerOnEscape = function (event) {
        if (event.keyCode === 27) {
          this.closeLayer($layer);


          this.options.$body.off(`keydown.${this.options.evtNamespace}`);
        }
      };

      this.options.$body.on(`keydown.${this.options.evtNamespace}`, _closeLayerOnEscape.bind(this));
    }


    if (o.closeTriggers && o.closeTriggers.length > 0) {
      $(o.closeTriggers).each((i, e) => {
        const $link = $layer.find(e);

        const _closeLayerWithTriggers = function () {
          this.closeLayer($layer);
        };

        $link.click(_closeLayerWithTriggers.bind(this));
      });
    }

    if ((o.onOpen && o.onOpen.length > 0) && (o.onClose && o.onClose.length > 0)) {
      this._deprecated('onOpen/onClose method is no longer supported - please use spartaEventUtilitys and spartaEventUtility.MODAL_OPENED/MODAL_CLOSED');
    }


    const addContent = function (content) {
      $layer.find('.site-specific-placeholder-content').html(content);
      resizeContentBody.call(this);
    };


    const replaceContent = function (content) {

      const layer = $layer instanceof jQuery && $layer.length >= 1 ? $layer[0] : $layer;
      if (!layer) return false;


      let target = layer.querySelector(`#${contentId}`, `.${contentId}`);
      let loading = layer.querySelector('.spa-loading');
      let buttonGroup = target.querySelector('.spa-btn-group');
      let title = target.querySelector('h3');
      let addContent = target.querySelector('.site-specific-placeholder-content');
      let closeButton = layer.querySelector(`#${contentId}SpartaUILayerClose`);


      document.activeElement.blur();



      let html = document.createElement("div");
      html.classList.add('content');


      if (title) html.appendChild(title);


      if (typeof content === 'string') {
        html.insertAdjacentHTML('beforeend', content); 
      }

      else {
        html.appendChild(content);
      };


      if (addContent) html.appendChild(addContent);
      if (buttonGroup) html.appendChild(buttonGroup);


      if (loading) loading.remove();


      target.querySelector('.content').remove();


      target.appendChild(html);
      target.style.display = 'block'; 
    };

    const addLoader = function(text) {

      const layer = $layer instanceof jQuery && $layer.length >= 1 ? $layer[0] : $layer;
      if (!layer) return false;


      let content = layer.querySelector(`#${contentId} .content`, `.${contentId} .content`);
      content.style.display = 'none';


      const loadingText = text || o.loadingText;
      let spaBody = layer.querySelector('.spa-body');
      let loading = document.createElement("div");
      loading.innerHTML= loadingText;
      loading.classList.add('spa-loading');
      spaBody.appendChild(loading);
    };


    o.returnFocusToLink.addClass(this.options.openClass);


    spartaEventsUtility.pub(EVENTS.MODAL_OPENED, {
      type: o.type,
      contentId: o.contentId,
      layer: $layer,
      addLoader,
      addContent,
      replaceContent
    });

    $layer.attr('aria-hidden', false);



    if (o.dynamicContent === false) {
      setTimeout(() => {
        if (o.closeButton === false) {
          $layer.find('.spa-header > div').trigger('focus');
        }
        else {
          $closeButton.trigger('focus');
        }
      }, 75);
    };

      }











  closeLayer(layer) {

    const $layer = (typeof layer === 'undefined') ? $(`.${this.options.layerClass}`) : ((typeof layer === 'string') ? this.options.$applicationContainer.find(`#${layer}`).slice(0, 1) : $(layer));
    focusTrap.removeTrap();

    if ($layer.length === 0) {
      return;
    }

    const _onEachItem = function (origLayer, index, element) {
      const $this = $(element);

      const o = $this.data() || {};

      const layerType = '';
      let $returnFocusToLink = o.returnFocusToLink;
      const isCurrentlyShowing = ($this.css('display') !== 'none');


      if (!isCurrentlyShowing) return;


      if ($layer.length === 1) {

        if (!($returnFocusToLink instanceof $)) {
          $returnFocusToLink = this.options.$applicationContainer.find($returnFocusToLink).slice(0, 1);
        }

        if ($returnFocusToLink.length && $returnFocusToLink.is(':visible')) {
          $returnFocusToLink
            .removeClass(this.options.openClass)
            .focus();
        } else {
          this.options.$applicationContainer.focus();
        }
      }


      if ($this.hasClass(this.options.modalLayerClass)) {
        this._closeModalLayer($this);
      } else if ($this.hasClass(this.options.infoLayerClass)) {
        this._closeInfoLayer($this);
      }



      spartaEventsUtility.pub(EVENTS.MODAL_CLOSED, {
        eventType: EVENTS.MODAL_CLOSED,
        type: o.type,
        contentId: o.contentId,
        layer: $layer,
      });

      $this.data('returnFocusToLink', null);

      $this.attr('aria-hidden', true);


      if ($this.hasClass(this.options.modalLayerClass)) {
        this._bodyUnfreezeScroll($this);
        this.options.$applicationContainer.removeClass('spa-ui-modal-open');
      } 

      else if ($this.hasClass(this.options.infoLayerClass)) {
        this.options.$applicationContainer.removeClass('spa-ui-tooltip-open');
      }
    };


    $layer.each(_onEachItem.bind(this, layer));

    this.options.$body.off(`click.${this.options.closeLayerNameSpace}`);
  }







  _keepPageFromScrolling() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.options.$body.css('top', -scrollTop);
  }







  _bodyFreezeScroll($layer) {
    if ($layer.length) {

      if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
        this._keepPageFromScrolling();
      }

      this.options.$body.addClass('spa-ui-freeze-scroll');
      spartaEventsUtility.pub(EVENTS.FREEZE_SCROLL);
    }
  }






  _returnScrollLocation() {
    const computedStyles = window.getComputedStyle(document.body, null);
    const topValue = computedStyles.getPropertyValue('top');
    const topValueToInteger = Math.abs(parseInt(topValue, 10));
    window.scrollTo(0, topValueToInteger);
    this.options.$body.css('top', '');
  }







  _bodyUnfreezeScroll($layer) {
    if ($layer.length && this.options.$body.hasClass('spa-ui-freeze-scroll')) {

      this.options.$body.removeClass('spa-ui-freeze-scroll');


      if (!this.options.$body.hasClass('spa-ui-no-js-scroll')) {
        this._returnScrollLocation();
      }

      spartaEventsUtility.pub(EVENTS.UNFREEZE_SCROLL);
    }
  }






  _closeModalLayer($layer) {
    $layer.css('display', 'none');

    const $spaContent = $layer.find('.content');
    $spaContent[0].scrollTop = 0;
    const $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

    if ($alphaLayer) {
      $spaContent.off('scroll.uilayer_content');
    }

    this.updatePageContainerADA(false);
  }







  _closeInfoLayer($layer) {
    if ($layer.hasClass('spa-ui-animate-fadeInDown')) {
      $layer
        .removeClass('spa-ui-animate-fadeInDown')
        .addClass('spa-ui-animate-fadeOutUp');
    } else if ($layer.hasClass('spa-ui-animate-fadeInUp')) {
      $layer
        .removeClass('spa-ui-animate-fadeInUp')
        .addClass('spa-ui-animate-fadeOutDown');
    }

    const $spaContent = $layer.find('.content');
    $spaContent[0].scrollTop = 0;
    const $alphaLayer = $spaContent.find('.spa-content-alpha-layer');

    if ($alphaLayer) {
      $spaContent.off('scroll.uilayer_content');
    }
  }








  _getNextZindex(o) {
    return this.options.nextZIndex++;
  }
















  _formatCloseLink(o) {
    const _updateAdaCloseLink = function (layerHeaderText) {
      o.closeAdaText += (o.type === "modal") ?
                        (o.closeAdaText != undefined ? o.closeAdaText : (spartaGlobalFunctions.getGlobalParams("closeModalADAText") || "modal")) :
                        (spartaGlobalFunctions.getGlobalParams("closeLayerADAText") || "layer") ;
      if (layerHeaderText) {
          o.closeAdaText += `${o.closeAdaTextSpacer} ${layerHeaderText}`;
      }
    };

    if (o.closeAdaTextOverride) {
      _updateAdaCloseLink(o.closeAdaTextOverride);
    } else if (o.$content.find('h3').length > 0) {
      _updateAdaCloseLink(o.$content.find('h3:first').text());
    } else if (o.$content.find('h2').length > 0) {
      _updateAdaCloseLink(o.$content.find('h2:first').text());
    } else if (o.$content.find('h4').length > 0) {
      _updateAdaCloseLink(o.$content.find('h4:first').text());
    } else if (o.$content.find('.ada-title').length > 0) {
      _updateAdaCloseLink(o.$content.find('.ada-title').text());
    } else if (o.returnFocusToLink.length > 0 && o.returnFocusToLink.text().length > 0 &&
      !o.returnFocusToLink.is('[data-sparta-container]')) {
      _updateAdaCloseLink(o.returnFocusToLink.text().replace(/layer/g, ''));
    } else if (o.$content.find('p').length > 0) {
      _updateAdaCloseLink(o.$content.find('p:first').text().substr(0, 50));
    } else {
      _updateAdaCloseLink();
    }
  }

















  _getLayerPos($layer, $link) {

    const link = $link[0].getBoundingClientRect();


    const viewport = {
      width: this.options.$window.width(),
      height: this.options.$window.height(),
    };


    const layer = {
      width: $layer.width(),
      height: $layer.height(),
    };

    const center = this._getLinkCenter(link);


    return {
      x: this._getLayerX(link, layer, viewport),
      y: this._getLayerY(link, layer, viewport),
      center,
    };
  }








  _getLinkCenter(link) {
    return link.left + (link.width / 2);
  }













  _getLayerY(link, layer, viewport) {

    return (link.top >= layer.height) ? -1 : 1;
  }
















  _getLayerX(link, layer, viewport) {
    const center = this._getLinkCenter(link);


    let x = 0;

    if (layer.width >= viewport.width) {

      x = 3;
    } else if ((layer.width >= link.right) && (layer.width >= viewport.width - link.left)) {

      x = 2;
    } else if (viewport.width - link.left >= layer.width) {

      x = -1;
    } else if (link.right - layer.width >= 0) {

      x = 1;
    }

    return x;
  }










  _openModalLayer(o, $layer, $link) {

    this.closeLayer();



    const _widthValue = o.width || o.modalLayer.width;

    $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);


    if ($layer.length > 0) {

      if (o.interstitialType) {
        $layer.find('.spa-body').html(this._generateInterstitialContentHTML(o, $link));
      }

      $layer.removeClass('full-width');
      $layer.css('display', 'block');
    } else {

      this._formatCloseLink(o);


      const modalLayerElement = document.createElement('div');
      modalLayerElement.id = o.layerId;
      modalLayerElement.style.zIndex = this._getNextZindex(o);

      const htmlOptions = {
        widthValue:  _widthValue === 'auto' ? _widthValue : `${_widthValue}px`,
      };

      let spaBody = '';

      const lang = (spartaStoreUtility.getData('lang') === 'en-us' ? 'en' : 'es');
      const branding = o.interstitialType && o.interstitialType.length > 0 ? o.interstitialBranding : o.branding;

      if (branding) {
        htmlOptions.customHeaderStyles = {
          'background-image': `url('${this.layers.modalHeaderBackgrounds[branding]}')`,
        };
        o.optionalClasses += `${(o.optionalClasses && o.optionalClasses.length > 0 ? ' ' : '')}spa-ui-modal-interstitial`;
        o.interstitialBranding = branding;
      }


      if (o.interstitialType) {
        spaBody = this._generateInterstitialContentHTML(o, $link, modalLayerElement);
      } else {
        this._addClassesToElement(modalLayerElement, [o.layerClass, o.modalLayer.class].concat(o.optionalClasses.split(' ')));

        spaBody = (o.$content instanceof $ ? o.$content.detach().removeClass('hide') : o.$content);
      }


      const modalLayerHTML = this._generateModalHTML(o, htmlOptions);
      modalLayerElement.innerHTML = modalLayerHTML;
      this.options.$applicationContainer.append(modalLayerElement);

      const newModal = this.options.$applicationContainer.find(`#${modalLayerElement.id}`);
      if (spaBody instanceof $) {
        spaBody.appendTo(newModal.find('.spa-body'));
      } else {
        newModal.find('.spa-body').append(spaBody);
      }
    }


    this._updateLinksDataCollection();

    $layer = this.options.$applicationContainer.find(`#${o.layerId}`).slice(0, 1);


    this._bodyFreezeScroll($layer);
    this._addAlphaLayer($layer.find('.spa-body'));


    const $modalDialog = $layer.find('.spa-dialog');
    const _layerWidth = $modalDialog.width();


    $modalDialog.addClass(classDefaults.layerPosition);


    if (o.position.browserWidth <= _layerWidth) {
      $modalDialog.addClass('full-width');
    }


    const closeModal = function (event) {
      this.options.$window.off('resize.closeModal orientationchange.closeModal');
      this.closeLayer(o.layerId);
    };

    this.options.$applicationContainer.find('.close-interstitial.spa-btn').off('click').on('click', closeModal.bind(this));


    focusTrap.setContainer($modalDialog[0]).attachTrap();
    this.updatePageContainerADA(true);

    return $layer;
  }









  _generateModalHTML(o, htmlOptions) {
    let customHeaderStyles = '';

    if (htmlOptions.customHeaderStyles) {
      _.each(htmlOptions.customHeaderStyles, (value, key) => {
        customHeaderStyles += `${key}:${value};`;
      });
    }

    const describedBy = o.describedBy ? ` aria-describedby="${o.describedBy}"` : '';
    const disabledCloseFocusSetter = o.closeButton === false ? `<div class="ada-hidden" tabindex="-1">${o.closeText}${o.closeAdaText}</div>` : ``;

        const modalHTML = `
             <div class="spa-dialog" role="dialog" aria-labelledby="${o.contentId}_title"${describedBy} style="z-index: ${this._getNextZindex(o)}; width: ${htmlOptions.widthValue};">
                 <div class="spa-content">
                     <div class="spa-header${(o.interstitialBranding ? ` ${o.interstitialBranding}` : '')}"${customHeaderStyles ? ` style="${customHeaderStyles}"` : ''}>
                        ${disabledCloseFocusSetter} 
                        <a role="button" id="${o.layerCloseId}" class="spa-ui-layer-close svg-button${((o.interstitialType || o.adaCloseFocus) ? ' svg-button--dark-bg close-interstitial' : '')}${(!o.closeButton ? ' hide' : '')}" href="javascript:void(0);">
                             <span class="ada-hidden">${o.closeADALabel}${o.closeText}${o.closeAdaText}</span>
                             <span class="spa-close-x" aria-hidden="true">×</span>
                         </a>
                     </div>
                     <div class="spa-body"></div>
                 </div>
             </div>
         `;

    return modalHTML;
  }








  _addAlphaLayer($baseLayer) {
    const $spaBody = $baseLayer.hasClass('spa-body') ? $baseLayer : $baseLayer.find('.spa-body');
    const $alphaLayer = $baseLayer.find('.spa-content-alpha-layer');

    if ($alphaLayer.length) {
      $alphaLayer.remove();
    }

    $baseLayer.append('<div class="spa-content-alpha-layer"></div>');


    if ($spaBody.find('.content').length === 0) {
      return false;
    }


    const myInterval = setInterval(() => {
      const newHeight = $spaBody.find('.content')[0].scrollHeight;
      this._showHideAlphaOverlay($spaBody.find('.content')[0], $spaBody.find('.spa-content-alpha-layer'));

      if (newHeight && newHeight > 0) {
        clearInterval(myInterval);


        const $spaContent = $baseLayer.find('.content');
        const $alphaLayer = $baseLayer.find('.spa-content-alpha-layer');

        if ($alphaLayer) {
          if ($spaContent[0].scrollHeight > $spaContent[0].clientHeight + 1) {
            $alphaLayer.css('display', 'block');
          }

          $spaContent
            .on('scroll.uilayer_content', (event) => {
              this._showHideAlphaOverlay(event.currentTarget, $alphaLayer);
            });
        }
      }
    }, 10);
  }









  _showHideAlphaOverlay(currentTarget, $alphaLayer) {
    let displayValue = 'none';


    const alphaLayerHeight = 40;


    if (currentTarget.scrollHeight > alphaLayerHeight) {

      if (currentTarget.scrollTop + currentTarget.clientHeight + 1 < currentTarget.scrollHeight) {
        displayValue = 'block';
      }
    }

    $alphaLayer.css('display', displayValue);
  }










  _openInfoLayer(o, $layer, $link) {

    let _widthValue;
    let _sizeClass;
    let _zIndex;
    let withinModal = false;
    const linkOptions = $link.data('options') || {};
    const tooltipMaxHeight = linkOptions.maxHeight || null


    let _self = this;


    if (this.options.$applicationContainer.find(`.${classDefaults.modalLayerClass}`).find($link).length === 0) {     
      this.closeLayer();
    }

    else {
      withinModal = true;
    }

    $layer = this.options.$applicationContainer.find(`#${o.layerId}`);

    if (!$layer.find('.spa-layer-content').length) {

      const _contentLength = o.$content.find(' > :not(".ada-hidden")').text().replace(/ {2}/g, '').length;

      if (_contentLength < o.infoLayer.width.small.chars) {
        _widthValue = o.infoLayer.width.small.width;
        _sizeClass = o.infoLayer.width.small.class;
      } else if (_contentLength < o.infoLayer.width.medium.chars) {
        _widthValue = o.infoLayer.width.medium.width;
        _sizeClass = o.infoLayer.width.medium.class;
      } else {
        _widthValue = o.infoLayer.width.large.width;
        _sizeClass = o.infoLayer.width.large.class;
      }


      this._formatCloseLink(o);


      const infoLayerElement = document.createElement('div');

      _zIndex = this._getNextZindex(o);

      infoLayerElement.id = o.layerId;

      this._addClassesToElement(infoLayerElement, [o.layerClass, o.infoLayer.class, _sizeClass]);

      const infoLayerHTML = `
                 <div class="spa-layer-content" role="dialog" aria-labelledby="${o.contentId}_title">
                     <div class="spa-content">
                         <div class="spa-header">
                             <a role="button" id="${o.layerCloseId}" class="spa-ui-layer-close svg-button" href="javascript:void(0);">
                                 <span class="ada-hidden">${o.closeText}${o.closeAdaText}</span>
                                 <span class="spa-close-x" aria-hidden="true">×</span>
                             </a>
                         </div>
                         <div class="spa-body"></div>
                         <div tabindex="0" class="ada-hidden ada-visible-focus">${o.endContentMsg}</div>
                     </div>
                 </div>
             `;

      const layerContent = o.$content.removeClass('hide').detach();
      if (tooltipMaxHeight) layerContent.find('.content').css('max-height', `${tooltipMaxHeight}px`);

      infoLayerElement.innerHTML = infoLayerHTML;
      $link.after(infoLayerElement);
      $layer = this.options.$applicationContainer.find(`#${o.layerId}`);

      $layer
        .data('linkElement', $link[0].id)
        .find('.spa-body')
        .append(layerContent);
    } else if ($layer.hasClass('spa-ui-animate-fadeOutUp') || $layer.hasClass('spa-ui-animate-fadeOutDown')) {
      $layer.show();
      $link.after($layer); 
    }


    $layer.removeClass('spa-ui-info-modal spa-ui-animate-fadeOutUp spa-ui-animate-fadeOutDown');


    _self._tooltipPositioning(_self, o, $layer, $link, withinModal);


    this.options.$window.on('scroll resize', function() {
      _self._tooltipPositioning(_self, o, $layer, $link, withinModal);
    });











    return $layer;
  }









  _addClassesToElement(element, classes) {
    classes.forEach((val) => {
      if (val && val.length > 0) {
        element.classList.add(val);
      }
    });
  }

  _getElementPosition(element, position) {
    const bodyRect = document.body.getBoundingClientRect();
    const elemRect = element[0].getBoundingClientRect();
    const appRect = this.options.$applicationContainer[0].getBoundingClientRect();

    if (position === 'top') {
      return elemRect.top - appRect.top;
    }
    return elemRect.left - appRect.left;
  }











  _generateInterstitialContentHTML(o, $link, modalLayerElement = null) {






    if (o.interstitialType !== 'leaving-site' && o.interstitialType !== 'language-change' && o.interstitialType !== 'leaving-and-language') {
      this._debug('Use one of the standard interstitialType values: language-change, leaving-site, leaving-and-language');
    }

    if (o.interstitialBranding !== 'default' && o.interstitialBranding !== 'edge' && o.interstitialBranding !== 'enterprise' && o.interstitialBranding !== 'co-brand') {
      this._debug('Use one of the standard interstitialBranding values: edge, enterprise, co-brand OR leave this property out of your config completely for a default value of "default"');
    }

    const lang = (spartaStoreUtility.getData('lang') === 'en-us' ? 'en' : 'es');
    const interstitialContent = this.layers[o.interstitialType] || {};
    const interstitialGoBackText = interstitialContent.btnText2[o.interstitialBranding] || {};
    const continueLink = $link.attr('href');
    const anchorID = $link.attr('id');

    const classesToAdd = ['spa-ui-modal-interstitial', o.layerClass, o.modalLayer.class];

    if (o.optionalClasses) {
      classesToAdd.concat(o.optionalClasses.split(' '));
    }

    if (modalLayerElement) {
      this._addClassesToElement(modalLayerElement, classesToAdd);
    }

    const contentWrapperId = o.rel || 'modalContentInt';

    return `
         <div id="${contentWrapperId}">
           <h3>${interstitialContent.header}</h3>
           <div class="content">
             ${interstitialContent.body}
             <p class="site-specific-placeholder-content"></p>
             <p class="spa-btn-group">
               <a role="button" href="${continueLink}" ${(o.targetAction === 'new-tab' ? ' target="_blank"' : '')} id="${anchorID}${classDefaults.continueLinkPostfixID}" class="spa-btn spa-btn--small spa-btn--primary ${(o.targetAction === 'new-tab' ? ' close-interstitial' : '')}">
                 ${interstitialContent.btnText1}
               </a>
               <a role="button" href="javascript:void(0);" id="${anchorID}${classDefaults.backLinkPostfixID}" class="spa-btn spa-btn--small spa-btn--secondary close-interstitial">
                 ${interstitialGoBackText}
               </a>
             </p>
           </div>
         </div>`;
  }








  updatePageContainerADA(isHidden) {
    const $pageContainer = this.options.$document.find(classDefaults.spartaLayoutContainer);
    if ($pageContainer.length > 0) {
      $pageContainer.attr('aria-hidden', isHidden);
    }
  }






  _updateLinksDataCollection() {
    if (typeof cX === 'function') {
      cX('onload');
      this._debug('_updateLinksDataCollection(): cX scan for new links');
    }
  }







  _debug(msg) {
    if (this.options.debug) {
      if (window.console && console.log) {
        console.log('ui-layer debug: ', msg);
      }
    }
  }







  _deprecated(msg) {
    if (this.options.debug) {
      console.error(`ui-layer DEPRECATED: ${msg}`);
    }
  }










  _tooltipPositioning(_self, o, $layer, $link, tooltipWithinModal ) {

    const layerPosition = _self._getLayerPos($layer, $link);


    const linkViewportOffset = $link[0].getBoundingClientRect();
    const linkViewportOffsetTop = linkViewportOffset.top;
    const linkOptions = $link.data('options') || {};
    const tooltipDefaultPosition = linkOptions.position || null;


    const appBoundingRect = this.options.$applicationContainer[0].getBoundingClientRect();
    let newLeft = this._getElementPosition($link);
    const layerCenter = $layer.outerWidth() / 2;
    const linkCenter = $link.outerWidth() / 2;


    if (layerPosition.x === 0) { 
      if ($link.hasClass('icon-link')) { 
        newLeft = (newLeft - ($layer.outerWidth() * 0.8) + linkCenter);
        $layer.addClass('tooltip-icon-position');
      } else {
        newLeft = (newLeft - ($layer.outerWidth() * 0.5) + linkCenter);
      }
    } else if (layerPosition.x === 1) { 
      newLeft = (newLeft - $layer.outerWidth()) + $link.outerWidth();
      $layer.addClass('tooltip-right-position');
    } else if (layerPosition.x === 2) {
      newLeft = (appBoundingRect.right - layerCenter);
    } else if (layerPosition.x === -1) {
      $layer.addClass('tooltip-left-position');
      if ($link.hasClass('icon-link')) { 
        newLeft -= (40 - linkCenter);
      }
    };

    $layer.css({
      position: '',
      top: '',
      left: `${newLeft}px`,
      right: '',
      height: '',
      'max-width': ''
    });

    if (tooltipWithinModal === true || !window.matchMedia(spartaMediaQueryUtility.mediaQueries[1].mediaQuery).matches && layerPosition.x !== 3) {
      $layer.css({
        'max-width': `calc(100% - 20px)`
      });
    }


    if (layerPosition.y === -1 && tooltipDefaultPosition !== 'bottom') { 
      let newTop = (linkViewportOffsetTop - $layer.outerHeight()) - this.options.layerLinkOffset;
      if ($link.hasClass('icon-link')) {
        newTop += (this.options.layerIconOffset - 6);
      }
      $layer
        .css('top', `${newTop}px`)
        .addClass('spa-ui-animate-fadeInUp').removeClass('spa-ui-animate-fadeInDown')
        .addClass('tooltip-top-position');

            } else if (layerPosition.y === 1 || tooltipDefaultPosition === 'bottom') { 
      let newTop = (linkViewportOffsetTop + $link.outerHeight()) + this.options.layerLinkOffset;
      if ($link.hasClass('icon-link')) {
        newTop += this.options.layerIconOffset;
      }
      $layer
        .css('top', `${newTop}px`)
        .addClass('spa-ui-animate-fadeInDown').removeClass('spa-ui-animate-fadeInUp')
        .removeClass('tooltip-top-position');
    }


    if (!window.matchMedia(spartaMediaQueryUtility.mediaQueries[1].mediaQuery).matches && layerPosition.x !== 3) {
      $layer.css({
        left: tooltipWithinModal === true ? '' : '10px',
      });
    }

    if (tooltipWithinModal === true) {
      $layer.css({
        position: 'absolute',
        top: '',
        left: '',
        'margin-top': `${this.options.layerLinkOffset}px`,
      });
    }

    $layer.removeClass('spa-ui-info-modal');

  } 
}



const instance = new SpartaUILayersUtility();
spartaSingletonUtility('SpartaUILayersUtility', () => instance);
export default instance;
